var _defs, _path, _path2, _path3, _g, _g2, _path4, _text, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsApmEquipmentsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.46 318.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #fcfcfc;\n      }\n\n      .cls-3 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-4 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-2 {\n        font-family: Calibri-Bold, Calibri;\n        font-size: 72px;\n        font-weight: 500;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.55,53.69H28.82c-1.42,0-2.57-1.15-2.57-2.57s1.15-2.57,2.57-2.57h109.73c1.42,0,2.57,1.15,2.57,2.57s-1.15,2.57-2.57,2.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.66,225.03H3.79c-2.13,0-3.85-1.72-3.85-3.85s1.72-3.85,3.85-3.85h157.86c2.13,0,3.85,1.72,3.85,3.85s-1.72,3.85-3.85,3.85Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.14,105.03H34.59c-2.13,0-3.85-1.72-3.85-3.85v-38.5c0-2.13,1.72-3.85,3.85-3.85h97.54c2.13,0,3.85,1.72,3.85,3.85v38.5c0,2.13-1.72,3.85-3.85,3.85ZM38.45,97.33h89.84v-30.8H38.45v30.8Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.37,
    y: 114.01,
    width: 20.48,
    height: 20.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.68,
    y: 114.47,
    width: 20.48,
    height: 20.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 106.53,
    y: 114.01,
    width: 20.48,
    height: 20.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.37,
    y: 146.81,
    width: 20.48,
    height: 20.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.68,
    y: 147.27,
    width: 20.48,
    height: 20.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 106.53,
    y: 146.81,
    width: 20.48,
    height: 20.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.37,
    y: 180.25,
    width: 20.48,
    height: 20.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.68,
    y: 180.71,
    width: 20.48,
    height: 20.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 106.53,
    y: 180.25,
    width: 20.48,
    height: 20.48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.58,198.85h-63.37c-1.42,0-2.57-1.15-2.57-2.57v-91.03c0-1.42,1.15-2.57,2.57-2.57h63.37c1.42,0,2.57,1.15,2.57,2.57v91.03c0,1.42-1.15,2.57-2.57,2.57ZM145.77,193.71h58.24v-85.9h-58.24v85.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.55,196.82c-1.95,0-3.53-1.58-3.53-3.53v-85.99c0-1.95,1.58-3.53,3.53-3.53s3.53,1.58,3.53,3.53v85.99c0,1.95-1.58,3.53-3.53,3.53Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.14,53.69H34.59c-1.42,0-2.57-1.15-2.57-2.57V2.97c0-1.42,1.15-2.57,2.57-2.57h97.54c1.42,0,2.57,1.15,2.57,2.57v48.16c0,1.42-1.15,2.57-2.57,2.57ZM37.16,48.55h92.41V5.53H37.16v43.02Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(14.72 317.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 42.71,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 79.34,
    y: 0
  }, "M"))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.88,258.4H27.21C12.18,258.4-.06,246.16-.06,231.13V47.59C-.06,32.55,12.18,20.32,27.21,20.32h6.1c2.13,0,3.85,1.72,3.85,3.85s-1.72,3.85-3.85,3.85h-6.1c-10.79,0-19.57,8.78-19.57,19.57v183.53c0,10.79,8.78,19.57,19.57,19.57h111.66c10.79,0,19.57-8.78,19.57-19.57v-23.42c0-2.13,1.72-3.85,3.85-3.85s3.85,1.72,3.85,3.85v23.42c0,15.04-12.23,27.27-27.27,27.27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.3,96.68c-2.13,0-3.85-1.72-3.85-3.85v-45.24c0-10.79-8.78-19.57-19.57-19.57h-5.45c-2.13,0-3.85-1.72-3.85-3.85s1.72-3.85,3.85-3.85h5.45c15.04,0,27.27,12.23,27.27,27.27v45.24c0,2.13-1.72,3.85-3.85,3.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsApmEquipmentsWhite);
export default __webpack_public_path__ + "static/media/Icons_APMEquipments_White.58cadde3f3a79148d135862ee1e78437.svg";
export { ForwardRef as ReactComponent };